import "./App.css";
import { Route, Routes } from "react-router-dom";
import SignInSide from "./login";
import DashboardContent from "./pages/dashboard";
import ConfirmaEmail from "./pages/confirmaEmail";
import ChamadoCanfield from "./pages/chamadoCanfield";
import VerificaCertificado from "./pages/VerificaCertificado/index";
import React from "react";
import Faq from "./pages/faq";
import { Pj } from "./pages/Pj";

class Router extends React.Component {
  render() {
    return (
      <Routes basename={"/portal"}>
        <Route path={`/`} element={<SignInSide />} />
        <Route path={`${process.env.PUBLIC_URL}/`} element={<SignInSide />} />
        <Route
          path={`${process.env.PUBLIC_URL}/login`}
          element={<SignInSide />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/canfield`}
          element={<ChamadoCanfield />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/certificado`}
          element={<VerificaCertificado />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/dashboard`}
          element={<DashboardContent />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/confirma_email/:email/:codparc`}
          element={<ConfirmaEmail />}
        />
        <Route path={`${process.env.PUBLIC_URL}/faq`} element={<Faq />} />
        <Route path={`${process.env.PUBLIC_URL}/pj`} element={<Pj />} />
      </Routes>
    );
  }
}

export default Router;
